module.exports = __webpack_public_path__ + "img/中国石化体育协会@3x.24d13482.png";